import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/pro-light-svg-icons/faBook';
import { faComment } from '@fortawesome/pro-light-svg-icons/faComment';
import { faGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe';
import { useTranslation } from 'react-i18next';

import Tooltip from 'components/common/tooltip';
import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';
import { ChannelsStyled, IconWrapper } from 'components/customer/answer_panel/preview/answer_preview_channels';

export default function SuggestedReplyChannels() {
  const { t } = useTranslation();
  const isFeatureEnabled = useIsFeatureEnabled();
  const isFullHeight = isFeatureEnabled('fullHeightSidePanel');

  return (
    <ChannelsStyled $matchFooterHeight={isFullHeight}>
      <Channel message={t('Reference')}>
        <FontAwesomeIcon icon={faBook} />
      </Channel>
      <Channel message={t('Email')}>
        <i className="icon-email" />
      </Channel>
      <Channel message={t('Message')}>
        <FontAwesomeIcon icon={faComment} />
      </Channel>
      <Channel message={t('Public')}>
        <FontAwesomeIcon icon={faGlobe} />
      </Channel>
    </ChannelsStyled>
  );
}

export function Channel({ children, message }) {
  return (
    <Tooltip delay={800} message={message} position="top">
      <IconWrapper isDisabled isFocused={false}>
        {children}
      </IconWrapper>
    </Tooltip>
  );
}
